import React, {FC} from 'react';
import {ItemProps} from '../../types';

const Label: FC<ItemProps> = (
    {
        formItem,
    }
) => {
    return (
        <div className={`${formItem.classNames?.content || ""}`}>
            {formItem.itemOptions?.description}
        </div>
    );
};

export default Label;
